import i18next from 'i18next';

i18next.addResources('es', 'baseMap', {
  label: 'Mapa base',
  terrain: 'Relieve',
  light: 'Gris claro',
  satellite: 'Satélite'
});

i18next.addResources('en', 'baseMap', {
  label: 'Base map',
  terrain: 'Terrain',
  light: 'Light gray',
  satellite: 'Satellite'
});

i18next.addResources('pt', 'baseMap', {
  label: 'Mapa base',
  terrain: 'Relevo',
  light: 'Cinza claro',
  satellite: 'Satélite'
});
